export enum FanGroupStatus {
  DRAFT = 'DRAFT',
  ARCHIVED = 'ARCHIVED',
  PUBLISHED = 'PUBLISHED',
}

export enum AccessMode {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE',
  CODE_PROTECTED = 'CODE_PROTECTED',
  PUBLIC_OPTIONAL_CODE = 'PUBLIC_OPTIONAL_CODE',
}

export enum FanGroupVisibility {
  VISIBLE = 'VISIBLE',
  INVISIBLE = 'INVISIBLE',
}

/**
 * A fan group's billing modes are the same set a waiting list uses; the two were
 * declared separately, which made every value that crossed between them a type
 * error despite being the same string.
 */
export { BillingMode as FanGroupBillingMode } from './waitingList';

export enum PaymentMethod {
  CREDIT_CARD = 'CREDIT_CARD',
  MASTERPASS = 'MASTERPASS',
  IDEAL = 'IDEAL',
  VIRTUAL = 'VIRTUAL',
}
